import { createReducer, on } from '@ngrx/store';
import * as SportActions from '../actions/sport.actions';

export interface State {
  sports: any[]; 
  errorMessage: string | null;
  isLoading: boolean;
}
export const initialState: State = {
  sports: [],
  errorMessage: null,
  isLoading: false
};
export const sportReducer = createReducer(
  initialState,

  on(SportActions.loadSports, (state) => ({
    ...state,
    isLoading: true,
    errorMessage: null
  })),

  on(SportActions.loadSportsSuccess, (state, { sports }) => ({
    ...state,
    sports: sports,
    isLoading: false,
    errorMessage: null
  })),

  on(SportActions.loadSportsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    errorMessage: error
  }))
);